function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import classnames from 'classnames';
import { func } from '../util';
var makeChain = func.makeChain; // UIState 为一些特殊元素的状态响应提供了标准的方式，
// 尤其适合CSS无法完全定制的控件，比如checkbox，radio等。
// 若组件 disable 则自行判断是否需要绑定状态管理。
// 注意：disable 不会触发事件，请使用resetUIState还原状态

/* eslint-disable react/prop-types */

var UIState = /*#__PURE__*/function (_Component) {
  _inherits(UIState, _Component);

  var _super = _createSuper(UIState);

  function UIState(props) {
    var _this;

    _classCallCheck(this, UIState);

    _this = _super.call(this, props);
    _this.state = {};
    ['_onUIFocus', '_onUIBlur'].forEach(function (item) {
      _this[item] = _this[item].bind(_assertThisInitialized(_this));
    });
    return _this;
  } // base 事件绑定的元素


  _createClass(UIState, [{
    key: "getStateElement",
    value: function getStateElement(base) {
      var _this$props = this.props,
          onFocus = _this$props.onFocus,
          onBlur = _this$props.onBlur;
      return React.cloneElement(base, {
        onFocus: makeChain(this._onUIFocus, onFocus),
        onBlur: makeChain(this._onUIBlur, onBlur)
      });
    } // 获取状态classname

  }, {
    key: "getStateClassName",
    value: function getStateClassName() {
      var focused = this.state.focused;
      return classnames({
        focused: focused
      });
    } // 复原状态

  }, {
    key: "resetUIState",
    value: function resetUIState() {
      this.setState({
        focused: false
      });
    }
  }, {
    key: "_onUIFocus",
    value: function _onUIFocus() {
      this.setState({
        focused: true
      });
    }
  }, {
    key: "_onUIBlur",
    value: function _onUIBlur() {
      this.setState({
        focused: false
      });
    }
  }]);

  return UIState;
}(Component);

export default UIState;